var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"running",class:_vm.negative ? 'negative':''},[_c('span',{staticClass:"dot1"}),_c('span',{staticClass:"dot2"}),_c('span',{staticClass:"dot3"})])
}
var staticRenderFns = []

export { render, staticRenderFns }